import { ViewModel } from 'view_models/view_model'
import { Memo } from 'entities/memo'

export class MemoViewModel extends ViewModel<Memo> {}
